import React from 'react';

import { reduxHooks } from 'hooks';
import CourseCardMinimal from 'containers/CourseCardMinimal';

import './index.scss';

/**
 * Flat list view for courses not linked to any category/product ("Others").
 */
export const OthersView = () => {
  const { courses } = reduxHooks.useSelectedNavContent();
  return (
    <div className="others-view d-flex flex-wrap">
      {(courses || []).map((course) => (
        <CourseCardMinimal
          key={course.course_id}
          courseId={course.course_id}
          isActive={course.is_active}
          accessType={course.access_type}
          title={course.title}
          bannerImageUrl={course.banner_image_url}
          courseHomeUrl={course.course_home_url}
        />
      ))}
    </div>
  );
};

export default OthersView;
